import { render, staticRenderFns } from "./Step4_ClassSelection.vue?vue&type=template&id=5ec28b98&scoped=true"
import script from "./Step4_ClassSelection.vue?vue&type=script&lang=js"
export * from "./Step4_ClassSelection.vue?vue&type=script&lang=js"
import style0 from "./Step4_ClassSelection.vue?vue&type=style&index=0&id=5ec28b98&prod&lang=scss"
import style1 from "./Step4_ClassSelection.vue?vue&type=style&index=1&id=5ec28b98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec28b98",
  null
  
)

export default component.exports